import { pageService } from 'api/services/page'
import { PageType } from 'api/types/page'
import { AppContext } from 'contexts/AppContext'
import { useContext, useEffect, useState } from 'react'
import { deltaToHtmlQuill } from 'utils/quillToHtml'

export const Contacts = () => {
  const { settings } = useContext(AppContext)

  const [page, setPage] = useState<PageType | null>(null)

  const getPageDetails = async () => {
    if (!settings || !settings.dashboardContacts) return

    try {
      const response = (await pageService.getPage({
        id: Number(settings.dashboardContacts),
      })) as PageType
      setPage(response as PageType)

      if (!response?.content) return
      const html = deltaToHtmlQuill(response.content)
      setPage(prev => ({ ...prev, content: html } as PageType))
    } catch (error) {
      console.error('Failed to get webisode details', error)
    }
  }

  useEffect(() => {
    getPageDetails()
  }, [settings])

  if (!page) return null

  return (
    <div className="p-4 bg-black h-full space-y-1 overflow-y-auto">
      <div
        className="[&_h2]:text-body-3 [&_h2]:font-bold [&_h2]:text-primary-400 [&_p]:text-body-4 [&_p]:text-white [&_p]:pb-1 [&_a]:text-primary-400 [&_a]:underline"
        dangerouslySetInnerHTML={{ __html: page.content || '' }}
      />
    </div>
  )
}
